import pluralize from 'pluralize';
import { ChatItemSearchController } from './chatSearchInterface';
import { AiOutlineSearch } from 'react-icons/ai';

export function createChatItemSearchController(): ChatItemSearchController {
    return {
        useProps(context, item, props) {
            const plural = pluralize('document', item.result?.results.length ?? 0);
            return {
                Icon: AiOutlineSearch,
                label: item.result
                    ? `Found ${item.result.results.length} ${plural}`
                    : 'Searching documents',
            };
        },
    };
}
